import React from 'react';
import notepad_icon from "../icons/notepad-0.png";
import generic_icon from "../icons/directory_closed-1.png";
import '../applications-css/Application.css'
import "../applications-css/FileHandlers.css";

export class FileCreator extends React.Component {
  clickHandler(e, mode) {
    this.props.appExitHandler(e, this.props.appIndex);
    this.props.propMethod(e, mode);
  }

  render() {
    return(
      <div id="fileCreatorWrapper" className="outsideWrapper">
        <p data-testid="file-creator-prompt">Do you want to save changes to this file?</p>
        <span className="inlineButtons">
        <button onClick = {e => this.props.appExitHandler(e, this.props.appIndex)}> Cancel </button>
        <button onClick = {e => this.clickHandler(e, "discard")}> Don't Save </button>
        <button onClick = {e => this.clickHandler(e, "save")}> Save </button>
        </span>
      </div>
    )
  }
}

export class FileOpener extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(e, value, appIndex) {
    let periodIndex = value.lastIndexOf(".");
    let filename = value.slice(0, periodIndex);
    let filetype = value.slice(periodIndex + 1);
    this.props.appExitHandler(e, appIndex);
    this.props.propMethod(value, filename, filetype);
  }

  render() {
    return(
      <FileList
        flavorText = {"Select a file to open:"}
        buttonClickHandler = {this.clickHandler}
        appIndex = {this.props.appIndex}
      />
    );
  }
}

export class FileSaver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.clickHandler = this.clickHandler.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentDidMount() {
    var input = this.refs.inputFilename;
    input.addEventListener("keyup", this.enterHandler);
  }

  componentWillUnmount() {
    var input = this.refs.inputFilename;
    input.removeEventListener("keyup", this.enterHandler);
  }

  enterHandler = (e) => {
    if(e.keyCode === 13) {
      this.clickHandler(null);
    }
  }

  clickHandler(e) {
    let filename = this.refs.inputFilename.value;
    filename = filename.trim();
    this.props.propMethod(filename);
    this.props.appExitHandler(e, this.props.appIndex);
  }

  render() {
    return(
      <div id="fileSaverWrapper" className="outsideWrapper">
        <div id="saveAs" data-testid="saveas-prompt">Save As:</div>
        <textarea data-testid="saveas-filename-input" type="text" id="fileSaverInput" ref="inputFilename" spellCheck="false" rows="1" autoFocus>
          {this.props.filename}
        </textarea>
        <span className="inlineButtons">
          <button onClick = {e => this.props.appExitHandler(e, this.props.appIndex)}> Cancel </button>
          <button onClick = {e => this.clickHandler(e)}> Save</button>
        </span>
      </div>
    )
  }
}

export class FileExplorer extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  openFileError() {
    return(
      <span>
        <img width="32" src={this.props.warning_icon} draggable="false" alt={"Error"}/>
        <p> No program is able to open this file. </p>
      </span>
    );
  }

  programFinder(e, value, extension) {
    let program = "Popup Window";
    let propMethod = this.openFileError;
    if(extension === "txt") {
      program = "Notepad";
      propMethod = null;
    }
    if(extension === "png") {
      program = "Paint";
      propMethod = null;
    }
    this.props.appLauncherHandler(e, program, propMethod, value);
  }

  clickHandler(e, value) {
    let periodIndex = value.lastIndexOf(".");
    let filetype = value.slice(periodIndex + 1);
    this.programFinder(e, value, filetype);
  }

  render() {
    let allFiles = Object.keys(sessionStorage);
    allFiles.sort();
    return(
      <FileList
        flavorText = {"Files:"}
        buttonClickHandler = {this.clickHandler}
        appIndex = {this.props.appIndex}
      />
    )
  }
}

class FileList extends React.Component {
  constructor(props) {
    super(props);
    this.imageFinder = this.imageFinder.bind(this);
  }

  compare(a, b) {
    const filenameA = a.toUpperCase();
    const filenameB = b.toUpperCase();
    if(filenameA > filenameB) {
      return 1;
    }
    else if(filenameA < filenameB) {
      return -1;
    }
    return 0;
  }

  imageFinder(filename) {
    let periodIndex = filename.lastIndexOf(".");
    let filetype = filename.slice(periodIndex + 1);
    if(filetype === "txt") {
      return notepad_icon;
    }
    else {
      return generic_icon;
    }
  }

  render() {
    let allFiles = Object.keys(sessionStorage);
    let allFilesWithImages = [];
    allFiles.sort(this.compare);
    for(let i = 0; i < allFiles.length; i++){
      let image = this.imageFinder(allFiles[i]);
      allFilesWithImages.push(
        {
          name: allFiles[i],
          image: image,
        }
      )
    }
    return (
      <div data-testid="file-list" id="fileOpenerWrapper" className="outsideWrapper">
        {this.props.flavorText}
        {allFilesWithImages.map((value, index) => {
            let buttonTitle = "files-" + value.name + "-" + index
            return (
              <button
                data-testid={buttonTitle}
                onDoubleClick = {e => this.props.buttonClickHandler(e, value.name, this.props.appIndex)}
                key={index}
              >
                <div id="buttonContents">
                  <img src={value.image} draggable="false" alt={value}/>
                  <div id="buttonText">{value.name}</div>
                </div>
              </button>
            );
          })}
        </div>
    );
  };
}
